import { render, staticRenderFns } from "./school-loans.vue?vue&type=template&id=6a692357"
import script from "./school-loans.vue?vue&type=script&lang=js"
export * from "./school-loans.vue?vue&type=script&lang=js"
import style0 from "./school-loans.vue?vue&type=style&index=0&id=6a692357&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports